export default __webpack_public_path__ + "static/media/logojudge.6478acb5.png";